import { Col, Form, Input, Radio, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import {
  GENDERS,
  USER_FORM_STATUS,
} from '../../../../../common/constants';
import { formValidatorRules } from '../../../../../common/utils';
import CitySelect from '../../../../../components/CitySelect';
import CountrySelect from '../../../../../components/CountrySelect';
import PincodeSelectName from '../../../../../components/PincodeSelectName';
import SelectComponent from '../../../../../components/SelectComponent';
import StateSelect from '../../../../../components/StateSelect';

const { Item } = Form;
const { Group } = Radio;
const { required, email, name, phone, whitespaceNotAllowed } = formValidatorRules;

const AmbassadorForm = ({
  form,
  onFinish,
  handleShowPrompt,
  initialValues,
  isView,
  ambassadorDetail,
}) => {
  const [validationTriggered, setValidationTriggered] = useState(false);
  const [countryId, setCountryId] = useState('');
  const [stateId, setStateId] = useState(initialValues?.state);
  const [isStateIdChanged, setIsStateIdChanged] = useState(false);

  useEffect(() => {
    const initialValueFun = () => {
      form?.setFieldsValue({
        ...initialValues,
        country: countryId,
      });
    };
    setTimeout(initialValueFun, 300);
  }, [countryId]);

  const onFinishFailed = () => {
    setValidationTriggered(true);
  };

  return (
    <Form
      layout="vertical"
      form={form}
      onFinish={onFinish}
      onFieldsChange={handleShowPrompt}
      disabled={!!isView || ambassadorDetail?.isArchived}
      onFinishFailed={onFinishFailed}
      className={isView ? 'common-view-form' : 'form'}
      validateTrigger={validationTriggered ? 'onChange' : 'onSubmit'}
    >
      <Row gutter={[16, 0]}>
        <Col xs={24} sm={12} md={12} lg={8} xl={8} xxl={8}>
          <Item
            label="Name"
            name="name"
            rules={[{ ...required, message: 'Please Enter Name!' }, name]}
          >
            <Input allowClear placeholder="Enter Name" maxLength={100} />
          </Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8} xl={8} xxl={8}>
          <Item
            label="Gender"
            name="gender"
            rules={[
              {
                required: true,
                message: 'Please Select Gender!',
              },
            ]}
          >
            <SelectComponent placeholder="Select Gender" options={GENDERS} />
          </Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8} xl={8} xxl={8}>
          <Item
            label="Email ID"
            name="email"
            rules={[{ ...required, message: 'Please Enter Email!' }, email]}
          >
            <Input allowClear placeholder="Enter Email" maxLength={255} />
          </Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8} xl={8} xxl={8}>
          <Item
            label="Contact Details"
            name="contact"
            rules={[
              {
                ...required,
                message: 'Please Enter Contact Details!',
              },
              phone,
            ]}
          >
            <Input
              allowClear
              placeholder="Enter Contact Details"
              maxLength={10}
            />
          </Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8} xl={8} xxl={8}>
          <Item
            label="Address Line-1"
            name="address"
            rules={[
              {
                ...required,
                message: 'Please Enter Address Line-1!',
              },
            ]}
          >
            <Input allowClear placeholder="Enter Address Line-1" maxLength={250} />
          </Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8} xl={8} xxl={8}>
          <Item
            label="Address Line-2"
            name="address2"
            rules={[
              { ...required, message: 'Please Enter Address Line-2!' },
              whitespaceNotAllowed,
            ]}
          >
            <Input allowClear placeholder="Enter Address Line-2" maxLength={250} />
          </Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8} xl={8} xxl={8}>
          <Item
            label="Locality"
            name="locality"
            rules={[
              { ...required, message: 'Please Enter Locality!' },
              whitespaceNotAllowed,
            ]}
          >
            <Input allowClear placeholder="Enter Locality" maxLength={250} />
          </Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={8} xl={8} xxl={8}>
          <Item
            label="Landmark"
            name="landmark"
          >
            <Input allowClear placeholder="Enter Landmark" maxLength={250} />
          </Item>
        </Col>
        <div style={{ display: 'none' }}>
          <CountrySelect setCountryId={setCountryId} />
        </div>
        <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
          <Form.Item
            label="State"
            name="state"
            rules={[{ required: true, message: 'Please Select State!' }]}
          >
            <StateSelect
              countryId={countryId}
              setStateId={setStateId}
              userData={ambassadorDetail}
              onChange={(value) => {
                form?.setFieldsValue({
                  city: null,
                });
                setStateId(value);
                setIsStateIdChanged(true);
              }}
              isView={isView}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
          <Form.Item
            label="City"
            name="city"
            rules={[{ required: true, message: 'Please Select City!' }]}
          >
            <CitySelect
              stateId={stateId}
              userData={ambassadorDetail}
              isView={isView}
              isStateIdChanged={isStateIdChanged}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={12} lg={6} xl={6} xxl={6}>
          <Form.Item
            label="Pincode"
            name="pincode"
            rules={[{ required: true, message: 'Please Enter Pincode!' }]}
          >
            <PincodeSelectName userData={ambassadorDetail} />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Item
            label="Ambassador Active Status"
            name="isAmbassadorActive"
            initialValue={false}
            required
          >
            <Group options={USER_FORM_STATUS} />
          </Item>
        </Col>
      </Row>
    </Form>
  );
};

export default AmbassadorForm;
